import React, { useContext, useState, useEffect } from 'react';
import { classNames } from 'primereact/utils';
import { Sidebar } from 'primereact/sidebar';
import { RTLContext } from './App';
import { BaseApiServiceImpl } from './app_utils/api/BaseApiServiceImpl';
import { UserSessionUtils } from './app_utils/utils/UserSessionUtils';
import { formatAmountWithCommas } from './app_utils/utils/Utils';

const AppRightMenu = (props: any) => {
    const isRTL = useContext(RTLContext);
    const [walletBalance, setWalletBalance] = useState<number>(0);
    const [recentSms, setRecentSms] = useState<any[]>([]);
    const userId = UserSessionUtils.getUserDetails()?.user?.id;

    useEffect(() => {
        if (props.rightMenuActive && userId) {
            fetchWalletBalance();
            fetchRecentSms();
        }
    }, [props.rightMenuActive, userId]);

    const fetchWalletBalance = () => {
        new BaseApiServiceImpl("/api/v1/wallet-deposits/balance/" + userId)
            .getRequestWithJsonResponse({})
            .then((response) => {
                setWalletBalance(response?.data ?? 0);
            })
            .catch(() => {});
    };

    const fetchRecentSms = () => {
        new BaseApiServiceImpl("/api/v1/sms/ui")
            .getRequestWithJsonResponse({ offset: 0, limit: 5 })
            .then((response) => {
                setRecentSms(response?.records || []);
            })
            .catch(() => {});
    };

    const getStatusColor = (status: string) => {
        switch (status) {
            case 'Sent': return '#22c55e';
            case 'Failed': return '#ef4444';
            case 'New': return '#f59e0b';
            default: return '#6b7280';
        }
    };

    return (
        <Sidebar
            appendTo="self"
            visible={props.rightMenuActive}
            onHide={props.onRightMenuButtonClick}
            position={isRTL ? 'left' : 'right'}
            blockScroll={true}
            showCloseIcon={false}
            baseZIndex={1000}
            className={classNames('layout-rightmenu p-sidebar-sm fs-small py-3', isRTL ? 'pl-0 pr-3' : 'pl-3 pr-0')}
        >
            <div className={classNames('flex flex-column mt-3', { 'ml-3': !isRTL, 'mr-3': isRTL })}>
                <h6 className="header">QUICK STATS</h6>
                <div className="card mb-3" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: 'white' }}>
                    <span style={{ fontSize: '0.75rem', opacity: 0.8 }}>Wallet Balance</span>
                    <h4 className="m-0 mt-1" style={{ color: 'white' }}>
                        {formatAmountWithCommas(walletBalance, 'UGX')}
                    </h4>
                </div>
            </div>

            <div className={classNames('flex flex-column mt-4', { 'ml-3': !isRTL, 'mr-3': isRTL })}>
                <h6 className="header">RECENT SMS</h6>
                {recentSms.length > 0 ? (
                    <div>
                        {recentSms.map((sms: any, index: number) => (
                            <div
                                key={index}
                                className="flex flex-row align-items-start py-2"
                                style={{ borderBottom: index < recentSms.length - 1 ? '1px solid #eee' : 'none' }}
                            >
                                <i
                                    className="pi pi-circle-fill mr-2 mt-1"
                                    style={{ fontSize: '0.5rem', color: getStatusColor(sms.status) }}
                                />
                                <div className="flex flex-column" style={{ flex: 1 }}>
                                    <span className="font-bold" style={{ fontSize: '0.8rem' }}>
                                        {sms.phoneNumber}
                                    </span>
                                    <small className="text-500" style={{ fontSize: '0.7rem' }}>
                                        {sms.body?.substring(0, 25)}{sms.body?.length > 25 ? '...' : ''}
                                    </small>
                                    <small style={{ fontSize: '0.65rem', color: getStatusColor(sms.status) }}>
                                        {sms.status}
                                    </small>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="text-center py-3">
                        <i className="pi pi-inbox" style={{ fontSize: '1.5rem', color: '#ccc' }} />
                        <p className="text-500 mt-2" style={{ fontSize: '0.8rem' }}>No recent activity</p>
                    </div>
                )}
            </div>

            <div className={classNames('flex flex-column mt-4', { 'ml-3': !isRTL, 'mr-3': isRTL })}>
                <h6 className="header">QUICK LINKS</h6>
                <ul style={{ listStyle: 'none', padding: 0 }}>
                    <li className="py-1">
                        <a href="/send-sms" className="text-primary" style={{ textDecoration: 'none', fontSize: '0.85rem' }}>
                            <i className="pi pi-send mr-2"></i>Send SMS
                        </a>
                    </li>
                    <li className="py-1">
                        <a href="/wallet" className="text-primary" style={{ textDecoration: 'none', fontSize: '0.85rem' }}>
                            <i className="pi pi-wallet mr-2"></i>Top Up Wallet
                        </a>
                    </li>
                    <li className="py-1">
                        <a href="/sms-reports" className="text-primary" style={{ textDecoration: 'none', fontSize: '0.85rem' }}>
                            <i className="pi pi-chart-bar mr-2"></i>SMS Reports
                        </a>
                    </li>
                    <li className="py-1">
                        <a href="/email-reports" className="text-primary" style={{ textDecoration: 'none', fontSize: '0.85rem' }}>
                            <i className="pi pi-envelope mr-2"></i>Email Reports
                        </a>
                    </li>
                    <li className="py-1">
                        <a href="/profile" className="text-primary" style={{ textDecoration: 'none', fontSize: '0.85rem' }}>
                            <i className="pi pi-user mr-2"></i>My Profile
                        </a>
                    </li>
                </ul>
            </div>
        </Sidebar>
    );
};

export default AppRightMenu;
